<template>
  <v-layout
    row
    wrap
    color="transparent"
  >
    <!-- Title -->
    <v-flex xs12>
      <h3 class="text-capitalize ml-4 font-weight-regular">
        {{ $t('New Order') }}
        <!-- Action Buttons -->
        <v-chip>
          <v-icon>fiber_manual_record</v-icon>
          {{ $t('Draft Order') }}
        </v-chip>
      </h3>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderDraftHeader',

  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
